import { CountMetric } from '../../entities/count-metric';
import type { TrackCountRepository } from '../../repositories/track-count-repository';

export async function trackCountMetric(
  { publish, log }: TrackCountRepository,
  metric: CountMetric,
): Promise<void> {
  const result = CountMetric.safeParse(metric);
  if (result.success) {
    publish(result.data);
  } else {
    log({
      message: 'The metric is not valid',
      data: {
        metricName: metric.name,
        metricTags: metric.tags,
        rootCause: result.error,
      },
      context: 'client',
      type: 'error',
    });
  }
}
